import React, { ReactNode } from 'react';
import styled from '@emotion/styled';

export interface ListProps {
  /**
   * The HTML element to render. Defaults to 'p' element.
   */
  as: 'ol' | 'ul';
  /**
   * The react child to render
   */
  children: ReactNode;
  /**
   * The css class for the input. Handled internally by emotion
   */
  className?: string;
}

const List = ({ as, children, className }: ListProps) => {
  const Element = as;

  return <Element className={className}>{children}</Element>;
};

const StyledList = styled((props: any) => <List {...props} />)`
  ${() => ({
    li: {
      fontSize: 14,
    },
  })}
`;

export default StyledList;
